import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as complaintActions from '../../actions/Complaint';
import SearchComplaintForm from './SearchComplaintForm';
import {clearError} from '../../actions/Error';
class SearchComplaint extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            complaint: Object.assign({}, this.props.complaint)
        };
    }

    updateComplaintState = (event) => {
        const field = event.target.name;
        let complaint = Object.assign({}, this.state.complaint);
        complaint[field] = event.target.value;
        return this.setState({complaint: complaint});
    }

    searchComplaintByData = (event) => {
        event.preventDefault();
        this.props.searchComplaint(this.state.complaint.number, this.state.complaint.password);
    }
    
    clearError = () => this.props.clearError();

    render() {
        return (
            <SearchComplaintForm
                complaint={this.state.complaint}
                error={this.props.error}
                onClearError={this.clearError}
                onChange={this.updateComplaintState}
                onFormSubmit={this.searchComplaintByData} />
        );
    }
}
    
const mapStateToProps = (state) => {
    let complaint = {
        number: "",
        password: ""
    };
    return {
        complaint: complaint,
        error: state.error
    };
};
    
const mapDispatchToProps = (dispatch) => {
    return {
        clearError: () => dispatch(clearError()),
        searchComplaint: (number,password) => dispatch(complaintActions.searchComplaint(number,password))
    };
};

SearchComplaint.propTypes = {
    complaint: PropTypes.shape({
        number: PropTypes.string,
        password: PropTypes.string
    }),
    clearError: PropTypes.func,
    error: PropTypes.object,
    changeComplaintNumber: PropTypes.func,
    changeComplaintPassword: PropTypes.func,
    searchComplaint: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchComplaint);


// WEBPACK FOOTER //
// ./src/components/SearchComplaint/SearchComplaint.js